import React, { useState } from 'react';
import { Progress, Table } from 'antd';
import { checkRowOfRowPaid, getInterestRateRepayment } from '../../Investments/utils';
import { Repayment } from '../../Investments/redux/types';
import { dealTypes } from '../../../login/utils/Status';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import ExcutedAgreementAndUpdatedFilesModel from '../../Investments/modal/ExecutedAndUpdateFiles';
import { useNavigate } from 'react-router-dom';
import { DataRoom } from '../../deals/redux/types';
import { MdVisibility } from 'react-icons/md';

const InvestmentRepaymentTable: React.FC = () => {
    const navigate = useNavigate();

    const repayment = useSelector((state: RootState) => state.investments.repayment);
    const list = repayment ? [repayment] : [];

    const [openDocument, setOpenDocument] = useState(false);
    const [document, setDoument] = useState<{ updates: DataRoom[]; ExecutedAgreements: DataRoom[] }>({
        updates: [],
        ExecutedAgreements: [],
    });

    const redirectToDeal = (uuid: string) => {
        return navigate(`/deal/${uuid}`);
    };

    const columns = [
        {
            title: 'Deal Name',
            dataIndex: '',
            render: (record: Repayment) => (
                <span className="text-blue-400 deal_text_color" onClick={() => redirectToDeal(record.deal.uuid)}>
                    {record.deal.title}
                </span>
            ),
        },
        {
            title: 'Issuer Name',
            dataIndex: '',
            render: (record: Repayment) => <span>{record.issuer?.name || '-'}</span>,
        },
        {
            title: 'Country',
            dataIndex: '',
            render: (record: Repayment) => <span>{record.issuer?.country || '-'}</span>,
        },
        {
            title: 'Instrument Type',
            dataIndex: '',
            render: (record: Repayment) => <span>{record.deal.instrumentType || '-'}</span>,
        },
        {
            title: 'Tenor(months)',
            dataIndex: '',
            render: (record: Repayment) => <span>{record.deal.terms?.tenorInMonths || '-'}</span>,
        },
        {
            title: 'Interest Rate (p.a.)',
            dataIndex: '',
            render: (record: Repayment) => (
                <span>
                    {(dealTypes.equity !== record.deal.dealType &&
                        getInterestRateRepayment(record.investment.amount.currency, record)) ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Amount',
            dataIndex: '',
            render: (record: Repayment) => (
                <span>
                    {record.investment.amount &&
                        record.investment.amount.amountUpto2dp &&
                        `${
                            record.investment.amount.currency
                        } ${record.investment.amount.amountUpto2dp.toLocaleString()}`}
                </span>
            ),
        },
        {
            title: 'Status',
            dataIndex: '',
            render: (record: Repayment) => <span>{record.investment.status}</span>,
        },
        {
            title: 'Documents',
            dataIndex: '',
            render: (record: Repayment) => (
                <span className="text-center w-full">
                    {(record.executedAgreements.length > 0 || record.updates.length > 0) && (
                        <MdVisibility
                            color="#16365c"
                            className="cursor-pointer ml-1 text-xl md:text-2xl"
                            onClick={() => {
                                setDoument({
                                    updates: record.updates || [],
                                    ExecutedAgreements: record.executedAgreements || [],
                                });
                                setOpenDocument(true);
                            }}
                        />
                    )}
                </span>
            ),
        },
        {
            title: 'Repayment Status',
            dataIndex: '',
            render: (record: Repayment) => (
                <span>
                    {(record.repayments && record.repayments.length > 0 && (
                        <div className="cursor-pointer w-1/2">
                            <p className="text-center w-full">
                                {checkRowOfRowPaid(record.repayments)} / {record.repayments && record.repayments.length}
                            </p>
                            <Progress
                                showInfo={false}
                                strokeColor={{
                                    '0%': 'green',
                                    '100%': 'green',
                                }}
                                percent={
                                    (checkRowOfRowPaid(record.repayments) /
                                        ((record.repayments && record.repayments.length) || 0)) *
                                    100
                                }
                            />
                        </div>
                    )) ||
                        '-'}
                </span>
            ),
        },
    ];
    return (
        <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto w-full">
            <div className="px-4 py-4">
                <p className="text-lg pb-4 SourceSansPro-SemiBold">Investment</p>
                <ExcutedAgreementAndUpdatedFilesModel
                    updates={document.updates || []}
                    executedAgreements={document.ExecutedAgreements || []}
                    open={openDocument}
                    setOpen={setOpenDocument}
                />
                <Table
                    rowClassName={'table-row-dark'}
                    columns={columns}
                    dataSource={list}
                    className="w-full"
                    pagination={false}
                    rowKey={(record) => `${record.investment.uuid}_${record.deal.uuid}`}
                />
            </div>
        </div>
    );
};

export default InvestmentRepaymentTable;
